import { connect } from 'react-redux';
import { updateActiveNodeData } from '../../store/actions';
import { SidebarComponent } from './SidebarComponent';

const mapStateToProps = (state: any) => {
  return {
    generatorList: state.gen.generators
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateNodeData: (displayName: string, propertyname: string, nodetype: string) => updateActiveNodeData(dispatch, displayName, propertyname, nodetype)
  }
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  pure: false
})(SidebarComponent)



// WEBPACK FOOTER //
// ./src/Containers/Sidebar/index.tsx